

import * as React from "react";
import { useState, useMemo, useEffect } from "react";
import DataTable, { TableColumn } from "react-data-table-component";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import * as XLSX from "xlsx";
 import type { Fill } from 'exceljs';

import {
    Button,
    Card,
    Form,
    Col,
    Row,
    Badge,
    OverlayTrigger,
    Tooltip,
    Offcanvas, 
    Modal
} from "react-bootstrap";
import { BsSearch, BsFileEarmarkExcel, BsChatLeftTextFill} from "react-icons/bs";

import {  BsFileEarmarkText, BsCalendarCheck  } from "react-icons/bs";  // ← Agrega BsFileEarmarkText

import reportesServices from "../../../Services/Reportes/reportes.services";
import nominaServices from "../../../Services/Catalogos/Nomina"; 
import DTOPrenomina from "../../../DTO/Reportes/DTOPreNomina";
import { MsgInformativo } from "../../../Utils/Toast/msgInformativo";
import GestionChecadasComponent from "../../Catalogos/CatalogosReloj/EntradasSalidasRango";
import AdjuntoResponse from "../../../DTO/AdjuntoResponse";

import ModalPeriodosCerradosAdmin from "../../Catalogos/CatNomina/PeriodosCerrados";



/* ================== UTILIDADES DE FECHA ================== */
const currentDate = () => new Date().toISOString().split("T")[0];

const obtenerFechaFormateada = (fechaStr: string, opciones: Intl.DateTimeFormatOptions) => {
    if (!fechaStr) return "---";
    try {
        const parteFecha = fechaStr.split('T')[0];
        const [year, month, day] = parteFecha.split('-').map(Number);
        const d = new Date(year, month - 1, day);
        return isNaN(d.getTime()) ? "Fecha Inválida" : d.toLocaleDateString("es-MX", opciones);
    } catch (e) {
        return "Error Fecha";
    }
};

const formatearDiaHeader = (fechaStr: string) => {
    return {
        dia: obtenerFechaFormateada(fechaStr, { weekday: "long" }),
        fecha: obtenerFechaFormateada(fechaStr, { day: "2-digit", month: "2-digit", year: "numeric" })
    };
};

const formatTime = (dateTimeStr?: string | null) => {
    if (!dateTimeStr) return "N/A";
    const d = new Date(dateTimeStr);
    return isNaN(d.getTime()) ? "N/A" : d.toLocaleTimeString("es-MX", { hour: "2-digit", minute: "2-digit" });
};

const INCIDENCIA_ESTILOS: any = {
    FINJ: { bg: "danger", back: "#f8d7da", border: "#f5c6cb" },
    RET:  { bg: "warning", back: "#fff3cd", border: "#ffeeba" },
    VAC:  { bg: "info", back: "#d1ecf1", border: "#bee5eb" },
    PCS:  { bg: "success", back: "#d4edda", border: "#c3e6cb" },
    PSS:  { bg: "warning", back: "#fff3cd", border: "#ffeeba" },
    MAT:  { bg: "primary", back: "#cfe2ff", border: "#b6d4fe" },
    PPA:  { bg: "orange", back: "#ff9900cf", border: "#0d0a01" },
    ATRB: {  bg: "warning", back: "#FFE5B4",    border: "#ff9900cf" },
    ATRY: { bg: "dark",  back: "#D2B48C",   border: "#8B4513"   },
    HO:   { bg: "dark", back: "#e2e3e5", border: "#d6d8db" },
    ON:   { bg: "dark", back: "#e2e3e5", border: "#d6d8db" },
    DFT:  { bg: "success", back: "#c3e6cb", border: "#155724" },
    DDT:  { bg: "success", back: "#c3e6cb", border: "#155724" },
    HE2:  { bg: "indigo", back: "#e0cffc", border: "#d4bdfa" },
    HE3:  { bg: "purple", back: "#f5d0fe", border: "#f0abfc" },
    LAB:  { bg: "secondary", back: "#f2f2f2", border: "#dee2e6" },
    DEFAULT: { bg: "secondary", back: "#f8f9fa", border: "#dee2e6" }
};

interface DTOMatrizRow {
    numEmpleado: string;
    nombreEmpleado: string;
    departamento: string;
    oficina: string;
    [fecha: string]: any;
}

const renderTooltipDetalle = (celda: any, fecha: string, props: any) => (
    // <Tooltip id={`tooltip-${fecha}`} style={{ fontSize: 12 }}>
    <Tooltip
        id={`tooltip-${fecha}`} 
            {...props} 
            style={{ 
                ...props.style, 
                fontSize: 12, 
                zIndex: 9999 
            }}>
        <strong>
            {obtenerFechaFormateada(fecha, { weekday: "long", day: "2-digit", month: "long", year: "numeric" })}
        </strong>
        <hr style={{ margin: "4px 0" }} />
        <div>Entrada: {formatTime(celda.firstIn)}</div>
        <div>Salida: {formatTime(celda.lastOut)}</div>
        <div>Retardo: {celda.tiempoRetardo || "00:00"}</div>
        <div>VariacionHoraSalida: {celda.variacionHoraSalida || "00:00"}</div>
        <div className="text-info">Reloj: {celda.horasReloj}h</div>
            {celda.minutosExtraSolo > 0 && <div className="text-warning">Extras: +{Math.floor(celda.minutosExtraSolo/60)}h</div>}
            {celda.minutosDescuento < 0 && <div className="text-danger">Desc: -{Math.floor(Math.abs(celda.minutosDescuento)/60)}h</div>}
            <hr className="my-1 border-white" />

        <div>Horas: {celda.horasFinales}h</div>
        <div>HorasConModificacion: {celda.horasTotal } H</div>
        <div>Clave: {celda.clave}</div>
        <div>Descripción: {celda.descripcionClave}</div>
    </Tooltip>
);



export default function ReportePrenominaRh() {
    const [data, setData] = useState<DTOPrenomina[]>([]);
    const [inicio, setInicio] = useState(currentDate());
    const [fin, setFin] = useState(currentDate());
    const [filtro, setFiltro] = useState("");
    const [showMsg, setShowMsg] = useState(false);
    const [msg, setMsg] = useState("");
    const [header, setHeader] = useState("");

    const [showGestion, setShowGestion] = useState(false);
    const [empleadoParaEditar, setEmpleadoParaEditar] = useState("");
    const [fechaSeleccionada, setFechaSeleccionada] = useState("");
    

    const [adjuntos, setAdjuntos] = useState<AdjuntoResponse[]>([]);
const [tipoAdjunto, setTipoAdjunto] = useState<string>("HE");
const [archivoNuevo, setArchivoNuevo] = useState<File | null>(null);

const [adjuntosPorEmpleado, setAdjuntosPorEmpleado] = useState<Map<string, number>>(new Map());
const [showPeriodosModal, setShowPeriodosModal] = useState(false);

    

const cargarAdjuntos = async () => {
    if (!empleadoSeleccionado) return;
    
    try {
        const response = await nominaServices.listarAdjuntos(
            empleadoSeleccionado.numEmpleado,
            inicio
        );
        const lista = response.data || [];
        setAdjuntos(lista);

      
        setAdjuntosPorEmpleado(prev => {
            const newMap = new Map(prev);
            newMap.set(empleadoSeleccionado.numEmpleado, lista.length);
            return newMap;
        });
    } catch (error) {
        console.error("Error cargando adjuntos:", error);
        setAdjuntos([]);
        setAdjuntosPorEmpleado(prev => {
            const newMap = new Map(prev);
            newMap.set(empleadoSeleccionado.numEmpleado, 0);
            return newMap;
        });
    }
};




const manejarSubidaAdjunto = async () => {
    if (!archivoNuevo) {
        setMsg("Por favor selecciona un archivo");
        setHeader("Aviso");
        setShowMsg(true);
        return;
    }

    if (!empleadoSeleccionado) {
        setMsg("No hay empleado seleccionado");
        setHeader("Aviso");
        setShowMsg(true);
        return;
    }

    
   

    const formData = new FormData();
        formData.append("NumEmpleado", empleadoSeleccionado.numEmpleado);
        formData.append("FechaInicio", inicio);
        formData.append("FechaFin", fin);
        formData.append("TipoAdjunto", tipoAdjunto);
        formData.append("Archivo", archivoNuevo); 

            
            // console.log("Enviando FormData:");
            // for (let [key, value] of formData.entries()) {
            //     console.log(key, value);
            // }


    
    try {
           

                await nominaServices.subirAdjunto(formData);
    
                setMsg("Adjunto subido correctamente");
                setHeader("Éxito");
                setShowMsg(true);
                
                setArchivoNuevo(null);
                
                const fileInput = document.getElementById('inputArchivoNuevo') as HTMLInputElement;
                if (fileInput) fileInput.value = '';

                cargarAdjuntos(); 


        }   catch (error: any) {
        console.error("Error completo:", error);
        setMsg("Error al subir: " + (error.message || "Servidor no responde"));
        setHeader("Error");
        setShowMsg(true);
         }



};








    const [showNotaModal, setShowNotaModal] = useState(false);
    const [notaTemp, setNotaTemp] = useState("");
    const [empleadoSeleccionado, setEmpleadoSeleccionado] = useState<any>(null);


    useEffect(() => {
    if (showNotaModal && empleadoSeleccionado) {
        cargarAdjuntos();
    }
}, [showNotaModal, empleadoSeleccionado]);

    
   


    const manejarNotaRH = async (accion: 'GUARDAR' | 'ELIMINAR') => {
    if (!empleadoSeleccionado) return;

    const userIdRaw = localStorage.getItem("UserId")?.replace(/['"]+/g, '');
    const userId = parseInt(userIdRaw || "1", 10);

    const payload = {
        Accion: accion,
        NumEmpleado: empleadoSeleccionado.numEmpleado.toString(),
        FechaInicio: inicio,
        FechaFin: fin,
        Observacion: accion === 'GUARDAR' ? notaTemp : '',
        IdUsuarioRegistro: userId
    };

    try {
        const response = await nominaServices.MantenimientoObservacionRH(payload);

        // Cualquier respuesta 200 o resultado >= 0 es éxito
        if (response.status === 200 || response.data >= 0) {
            setShowNotaModal(false);
            setNotaTemp("");
            setMsg(accion === 'GUARDAR' 
                ? (notaTemp ? "Nota actualizada correctamente" : "Nota guardada correctamente")
                : "Nota eliminada correctamente"
            );
            setHeader("Éxito");
            setShowMsg(true);

            // ← AQUÍ ESTÁ LA CLAVE: Forzamos recarga completa del reporte
            generarReporte();
        } else {
            throw new Error("Respuesta inesperada del servidor");
        }
    } catch (error: any) {
        console.error("Error al guardar/eliminar nota RH:", error);
        setMsg("Error al procesar la nota: " + (error.response?.data?.title || error.message || "Intenta de nuevo"));
        setHeader("Error");
        setShowMsg(true);
    }
};


const cargarConteoAdjuntos = async () => {
    try {
        const response = await nominaServices.obtenerConteoAdjuntos(inicio, fin);

        const mapa = new Map<string, number>();

        response.data.forEach((item: any) => {
            mapa.set(item.NumEmpleado, item.TotalAdjuntos);
        });

        setAdjuntosPorEmpleado(mapa);

    } catch (error) {
        console.error("Error cargando conteo adjuntos:", error);
        setAdjuntosPorEmpleado(new Map());
    }
};


    

    const generarReporte = async () => {

    if (!inicio || !fin) {
        setHeader("Validación");
        setMsg("Debe seleccionar una fecha de inicio y una fecha de fin.");
        setShowMsg(true);
        return;
    }

    if (new Date(inicio) > new Date(fin)) {
        setHeader("Validación");
        setMsg("La fecha de inicio no puede ser mayor que la fecha de fin.");
        setShowMsg(true);
        return;
    }

    const storedUserId = localStorage.getItem("UserId")?.replace(/['"]+/g, '');
    if (!storedUserId) return;

    try {
        // 1️⃣ Cargar prenómina
        const response = await reportesServices.getRptPrenominaRh(inicio, fin);

        setData(response.data);

        // 2️⃣ Cargar conteo de adjuntos (después)
        await cargarConteoAdjuntos();

    } catch (error) {
        console.error("Error generando reporte:", error);
        setHeader("Error");
        setMsg("Error al generar el reporte.");
        setShowMsg(true);
    }
};

    

    


     const normalizar = (txt?: string) =>
  (txt || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // quita acentos
    .replace(/\./g, '')
    .trim();

   

    


const FILLS = {
  VERDE_ING: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFA9D08E' } } as Fill,
   ROSITA: {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FFFDE9D9' }
  } as Fill,


  VERDE:     { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE2EFDA' } } as Fill,
  NARANJA:   { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFE5CC' } } as Fill,
  AZUL:      { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD6EAF8' } } as Fill,
  MORADO:    { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE8DAEF' } } as Fill,
  AMARILLO:  { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFF3CD' } } as Fill,
  GRIS:      { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF2F2F2' } } as Fill,
};




const obtenerColorDepartamento = (departamento?: string): Fill | null => {
  const d = normalizar(departamento);

  if (!d || d === 'null') return FILLS.GRIS;

  
  if (d.includes('oficina general')) {
    return FILLS.GRIS;
  }

  
  if (d.includes('contabilidad')) {
    return FILLS.ROSITA;
  }

  
  if (d.includes('ingenieria') && d.includes('procesos')) {
    return FILLS.VERDE_ING;
  }


  if (
    d.includes('operaciones') &&
    (d.includes('mty') || d.includes('monterrey'))
  ) {
    return FILLS.NARANJA;
  }

  
  if (d.includes('operaciones') || d.includes('exportacion')) {
    return FILLS.AMARILLO;
  }


  if (d.includes('servicios administrativos')) {
    return FILLS.VERDE;
  }

   if (d.includes('cumplimiento normativo')) {
    return FILLS.AZUL;
  }
 
  if (d.includes('logistica')) {
    return FILLS.ROSITA;
  }

  
  return FILLS.GRIS;
};


const obtenerNumeroSemanaEspecial = (fecha: any): number => {
    
    const d = new Date(fecha);
    
    
    d.setDate(d.getDate() - 3);

    const primeroDeEnero = new Date(d.getFullYear(), 0, 1);
    const diasPasados = Math.floor((d.getTime() - primeroDeEnero.getTime()) / (24 * 60 * 60 * 1000));
    
    // Calculamos la semana transcurrida
    return Math.ceil((diasPasados + primeroDeEnero.getDay() + 1) / 7);
};




const downloadExcel = async (matrizData: any[], dias: string[]) => {
    const workbook = new ExcelJS.Workbook();

    // const numSemana = obtenerNumeroSemana(inicio);
    const numSemana = obtenerNumeroSemanaEspecial(inicio);
    const rangoFechasTexto = `${obtenerFechaFormateada(inicio, { day: '2-digit', month: '2-digit' })}_al_${obtenerFechaFormateada(fin, { day: '2-digit', month: '2-digit' })}`;
    const nombreArchivo = `PreNomina_Semana_${numSemana}_(${rangoFechasTexto}).xlsx`;

    // Separar empleados
    // const empleadosNLD = matrizData.filter(emp => !emp.numEmpleado.startsWith('04'));
    // const empleadosMTY = matrizData.filter(emp => emp.numEmpleado.startsWith('04'));

    
            const NUM_EMPLEADO_ANA_NLD = '040085'; // <-- reemplaza con el número real de Ana

            const esAnaNLD = (emp: any) => emp.numEmpleado === NUM_EMPLEADO_ANA_NLD;

            const empleadosNLD = matrizData.filter(emp =>
                !emp.numEmpleado.startsWith('04') || esAnaNLD(emp)
            );

            const empleadosMTY = matrizData.filter(emp =>
                emp.numEmpleado.startsWith('04') && !esAnaNLD(emp)
            );


            
    // Función reutilizable para crear cada hoja
    const crearHoja = async (worksheet: ExcelJS.Worksheet, datos: any[], nombreOficina: string) => {
        if (datos.length === 0) return;

        // 1. LOGO GEMCO
        try {
            const response = await fetch('/GEMCO.png');
            if (response.ok) {
                const blob = await response.blob();
                const arrayBuffer = await blob.arrayBuffer();
                const logoId = workbook.addImage({
                    buffer: arrayBuffer,
                    extension: 'png',
                });
                worksheet.addImage(logoId, { tl: { col: 0.1, row: 0.1 }, ext: { width: 95, height: 55 } });
            }
        } catch (e) {
            console.warn("Logo no encontrado");
        }

        // 2. ENCABEZADOS SUPERIORES
        worksheet.mergeCells('C1:H1');
        const title = worksheet.getCell('C1');
        title.value = 'GLAFIRO E. MONTEMAYOR Y CIA S.C.';
        title.font = { bold: true, size: 14 };

        worksheet.getCell('A4').value = 'Oficina:';
        worksheet.getCell('B4').value = nombreOficina;
        worksheet.getCell('A5').value = 'Fecha:';
        worksheet.getCell('B5').value = `Del ${obtenerFechaFormateada(inicio, { day: '2-digit' })} al ${obtenerFechaFormateada(fin, { day: '2-digit', month: 'long', year: 'numeric' })}`;
        worksheet.getCell('A6').value = 'Periodo:';
        worksheet.getCell('B6').value = `Semana ${numSemana}`;
        worksheet.getCell('B6').font = { bold: true };

        // 3. HEADERS DE LA TABLA
        const hRow = 8;
        const subHRow = 9;
        const colNotaSemanal = dias.length + 3;

        worksheet.getCell(hRow, 1).value = 'No de empleado';
        worksheet.getCell(hRow, 2).value = 'Nombre';
        worksheet.mergeCells(`A${hRow}:A${subHRow}`);
        worksheet.mergeCells(`B${hRow}:B${subHRow}`);

        dias.forEach((fecha, index) => {
            const col = index + 3;
            const info = formatearDiaHeader(fecha);
            worksheet.getCell(hRow, col).value = info.dia.toUpperCase();
            worksheet.getCell(subHRow, col).value = info.fecha;
            worksheet.getColumn(col).width = 16;
        });

        worksheet.getCell(hRow, colNotaSemanal).value = 'NOTA SEMANAL';
        worksheet.getCell(subHRow, colNotaSemanal).value = '(RH)';
        worksheet.getColumn(colNotaSemanal).width = 40;

        // Estilo encabezados
        [hRow, subHRow].forEach(r => {
            worksheet.getRow(r).eachCell(cell => {
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE0E0E0' } };
                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
                cell.font = { bold: true, size: 9 };
            });
        });

        // 4. DATOS DE EMPLEADOS
        let currentRow = 10;
        datos.forEach(emp => {
            const row = worksheet.getRow(currentRow);
            const fillDepto = obtenerColorDepartamento(emp.departamento);

            // Color por departamento en toda la fila
            if (fillDepto) {
                for (let i = 1; i <= colNotaSemanal; i++) {
                    const cellBase = row.getCell(i);
                    cellBase.fill = fillDepto;
                    cellBase.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                }
            }

            row.getCell(1).value = emp.numEmpleado;
            row.getCell(2).value = emp.nombreEmpleado;

            // Celdas diarias
            dias.forEach((fecha, index) => {
                const col = index + 3;
                const celda = emp[fecha];
                const cell = row.getCell(col);
                cell.alignment = { horizontal: 'center', vertical: 'middle' };

                if (celda && celda.clave) {
                    let etiquetas: string[] = [];
                    const clavesOriginales = celda.clave.split('/');

                   
                    const esSoloLab = celda.clave === "LAB" || celda.clave === "HO" || celda.clave === "NoInOut";
                if (!esSoloLab) {
                    if (celda.retardo || (celda.tiempoRetardo && celda.tiempoRetardo !== "00:00")) {
                        const [hrs, mins] = (celda.tiempoRetardo || "00:00").split(':');
                        etiquetas.push(`${hrs}:${mins.padStart(2, '0')} RET`);
                    }
                }

                    
                    if (celda.minutosExtraSolo > 0) {
                    const hPos = Math.floor(celda.minutosExtraSolo / 60);
                    const mPos = celda.minutosExtraSolo % 60;

                    const claves = celda.clave
                        .split('/')
                        .map((c: string) => c.trim().toUpperCase());

                    const tipoHE = claves.find((c: string) => c === 'HE2' || c === 'HE3') || 'HE';

                    etiquetas.push(
                        `${hPos}:${mPos.toString().padStart(2, '0')} ${tipoHE}`
                    );
                }


                    // Descuento o PSS
                    // if (celda.minutosDescuento < 0) {
                    //     const minDescAbs = Math.abs(celda.minutosDescuento);
                    //     etiquetas.push(`${Math.floor(minDescAbs / 60)}:${(minDescAbs % 60).toString().padStart(2, '0')} PSS`);
                    // } else if (clavesOriginales.includes('PSS')) {
                    //     etiquetas.push('PSS');
                    // }

                    if (celda.minutosDescuento < 0) {
    const minDescAbs = Math.abs(celda.minutosDescuento);
    const hNeg = Math.floor(minDescAbs / 60);
    const mNeg = minDescAbs % 60;
    etiquetas.push(`${hNeg}:${mNeg.toString().padStart(2, '0')} PPA`);
}

                    // Incidencias visibles (excluimos HO, LAB, RET, PSS y HE)
                    // clavesOriginales.forEach((cl: string) => {
                    //     if (!['LAB', 'RET', 'PSS', 'HO', 'NoInOut'].includes(cl) && !cl.includes('HE')) {
                    //         etiquetas.push(cl);
                    //     }
                    // });

                    // cell.value = etiquetas.length > 0 ? etiquetas.join(' / ') : "";

                    clavesOriginales.forEach((cl: string) => {
    // Si es PSS, se agrega la palabra sola (representa día completo)
    if (cl === 'PSS') {
        etiquetas.push('PSS');
    }
    // Otras incidencias (VAC, PCS, etc), excluyendo PPA y las que ya procesamos arriba
    else if (!['LAB', 'RET', 'PPA', 'PSS', 'HO', 'NoInOut'].includes(cl) && !cl.includes('HE')) {
        etiquetas.push(cl);
    }
});

cell.value = etiquetas.length > 0 ? etiquetas.join(' / ') : "";

                    

                        // 1. Preparamos las claves limpias para evitar fallos por espacios
                        const clavesLimpias: string[] = clavesOriginales.map((c: string) => c.trim().toUpperCase());

                        if (clavesLimpias.some((c: string) => ['PCS', 'DFT', 'DDT'].includes(c))) {
                            // VERDE (Permisos con goce, Festivos, Descansos)
                            cell.fill = {
                                type: 'pattern',
                                pattern: 'solid',
                                fgColor: { argb: 'FFE2EFDA' }
                            };
                        }
                        else if (clavesLimpias.includes('VAC')) {
                            // AZUL (Vacaciones)
                            cell.fill = {
                                type: 'pattern',
                                pattern: 'solid',
                                fgColor: { argb: 'FFD6EAF8' }
                            };
                        }
                        else if (clavesLimpias.includes('FINJ')) {
                            // ROJO (Faltas)
                            cell.fill = {
                                type: 'pattern',
                                pattern: 'solid',
                                fgColor: { argb: 'FFFFCCCC' }
                            };
                        }

                        if (clavesLimpias.includes('PPA')) {
                        cell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'FFFFE5CC' } // NARANJA CLARO
                        };
                    }
                                            else if (clavesLimpias.some((c: string) => ['PSS', 'RET'].includes(c)) || celda.retardo) {
                            // AMARILLO (Permisos sin goce, Retardos)
                            cell.fill = {
                                type: 'pattern',
                                pattern: 'solid',
                                fgColor: { argb: 'FFFFF3CD' }
                            };
                        }
                        // --- NUEVA CONDICIÓN PARA MORADO (HE) ---
                        else if (clavesLimpias.some((c: string) => c.includes('HE')) || celda.minutosExtraSolo > 0) {
                            // MORADO (Horas Extras)
                            cell.fill = {
                                type: 'pattern',
                                pattern: 'solid',
                                fgColor: { argb: 'FFE8DAEF' } 
                            };
                        }




                                        }
                                    });

            


        

            // --- REEMPLAZA DESDE AQUÍ ---
            const cellNotaRH = row.getCell(colNotaSemanal);
            let notasConcatenadas: string[] = [];

            
            dias.forEach(f => {
                const celdaDia = emp[f];
                if (celdaDia?.notaDiaria) {
                    const infoDia = formatearDiaHeader(f);
                    notasConcatenadas.push(`${infoDia.dia.toUpperCase()} (${infoDia.fecha.substring(0,5)}): ${celdaDia.notaDiaria}`);
                }
            });

            
            const fechaConNotaRH = dias.find(f => emp[f]?.notaRH);
            if (fechaConNotaRH && emp[fechaConNotaRH].notaRH) {
                notasConcatenadas.push(`NOTA RH: ${emp[fechaConNotaRH].notaRH}`);
            }

            
            if (notasConcatenadas.length > 0) {
                cellNotaRH.value = notasConcatenadas.join('\n');
                cellNotaRH.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF3E5F5' } };
                cellNotaRH.alignment = { wrapText: true, vertical: 'middle', horizontal: 'left' };
                cellNotaRH.font = { size: 8 };
                // Ajuste de altura para que quepan los renglones
                row.height = Math.max(20, notasConcatenadas.length * 12); 
            }
           

            currentRow++;
        });


        // 5. LEYENDA
        currentRow += 2;
        const infoHeader = worksheet.getRow(currentRow);
        infoHeader.getCell(1).value = "UNIDAD DE";
        infoHeader.getCell(2).value = "CLAVE";
        infoHeader.getCell(3).value = "DESCRIPCION";
        infoHeader.getCell(4).value = "TIPO PARA IMSS";
        infoHeader.getCell(5).value = "ESPECIFICACIONES";

        infoHeader.eachCell((cell) => {
            cell.font = { bold: true, size: 10 };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD9D9D9' } };
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            cell.alignment = { horizontal: 'center' };
        });

        const infoData = [
            ["Horas", "HE2", "Horas extras 2", "", "Solo permite fracciones despues de 30 minutos"],
            ["Horas", "HE3", "Horas extras 3", "", ""],
            ["Días", "PCS", "Permisos con goce de sueldo", "", ""],
            ["Días", "PSS", "Permisos sin goce de sueldo", "Ausencia", ""],
            ["Días", "ATRB", "Accidente de trabajo", "Incapacidad", "recabar de inmediato copia del certificado de incapacidad y alta medica"],
            ["Días", "ATRY", "Accidente de trayecto", "Incapacidad", "recabar de inmediato copia del certificado de incapacidad y alta medica"],
            ["Días", "ENFG", "Enf. Gral./Acc. Fuera trab.", "Incapacidad", "recabar de inmediato copia del certificado de incapacidad"],
            ["Días", "MAT", "Incapacidad por maternidad", "Incapacidad", "recabar de inmediato copia del certificado de incapacidad"],
            ["Días", "VAC", "Vacaciones a pagar", "Vacaciones", ""],
            ["Días", "FINJ", "Faltas injustificadas", "Ausencia", ""],
            ["Días", "CAST", "Días de castigo", "Ausencia", ""],
            ["Horas", "RET", "Retardos", "", "Permite fracciones antes de 30 minutos"],
            ["Día", "DFT", "Dia Festivo Trabajado", "", ""],
            ["Día", "DDT", "Dia de descanso trabajado", "", ""],
            ["Días", "HO", "Home Office", "", ""], 
            ["Horas", "PPA", "Permiso parcial  de ausencia", "", ""]
        ];

        infoData.forEach(item => {
            currentRow++;
            const row = worksheet.getRow(currentRow);
            row.getCell(1).value = item[0];
            row.getCell(2).value = item[1];
            row.getCell(3).value = item[2];
            row.getCell(4).value = item[3];
            row.getCell(5).value = item[4];
            row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
                if (colNumber <= 5) {
                    cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                    cell.font = { size: 9 };
                    if (colNumber === 5 && item[4] !== "") cell.font = { bold: true, size: 9 };
                }
            });
        });
    };

    // Crear las hojas
    const hojaNLD = workbook.addWorksheet('Nuevo Laredo');
    await crearHoja(hojaNLD, empleadosNLD, 'Nuevo Laredo');

    if (empleadosMTY.length > 0) {
        const hojaMTY = workbook.addWorksheet('MTY');
        await crearHoja(hojaMTY, empleadosMTY, 'MTY');
    }

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), nombreArchivo);
};




 




















    const filteredData = useMemo(() => {
        if (!filtro) return data;
        return data.filter(d => d.nombreEmpleado?.toLowerCase().includes(filtro.toLowerCase()) || d.numEmpleado?.toString().includes(filtro));
    }, [data, filtro]);

    const diasColumnas = useMemo(() => {
        const set = new Set<string>();
        filteredData.forEach(r => r.fecha && set.add(r.fecha));
        return Array.from(set).sort();
    }, [filteredData]);


    
    

    const matrizData = useMemo(() => {
    const mapa = new Map<string, DTOMatrizRow>();
    filteredData.forEach(row => {
        if (!mapa.has(row.numEmpleado)) {
            mapa.set(row.numEmpleado, { 
                numEmpleado: row.numEmpleado, 
                nombreEmpleado: row.nombreEmpleado, 
                departamento: row.departamento, 
                oficina: row.oficina 
            });
        }
        mapa.get(row.numEmpleado)![row.fecha] = {
            clave: row.claveNomina || (row.falta === 1 ? "FINJ" : "LAB"),
            
            horasFinales: row.horasTrabajadas,
            horasTotal: row.horasTotales, 
            tiempoRetardo: row.tiempoRetardo,
            retardo: row.retardo === 1,
            
            minutosExtraManual: row.minutosExtraManual, 
            minutosExtraSolo: row.minutosExtraSolo,    
            minutosDescuento: row.minutosDescuento,  
            variacionHoraSalida: row.variacionHoraSalida,   
            
            firstIn: row.firstIn,
            lastOut: row.lastOut,
            notaDiaria: row.notaSemanal,
            notaRH: row.notaRH,
            descripcionClave: row.descripcionClave
        };
    });
    return Array.from(mapa.values());
}, [filteredData]);

    const columnsMatriz: TableColumn<DTOMatrizRow>[] = [
        {
            name: "NumEmpleado",
            cell: row => (
                <Button variant="link" className="p-0 text-decoration-none fw-bold" onClick={() => { setEmpleadoParaEditar(row.numEmpleado); setFechaSeleccionada(inicio); setShowGestion(true); }}>
                    {row.numEmpleado}
                </Button>
            ),
            sortable: true, width: "120px",
        },
        

        { name: "Empleado", selector: row => row.nombreEmpleado, width: "220px", grow: 2, sortable: true },
        ...diasColumnas.map(fecha => {
            const { dia, fecha: fechaNum } = formatearDiaHeader(fecha);
            return {
                name: (
                    <div style={{ textAlign: "center", lineHeight: 1.1 }}>
                        <div style={{ fontSize: 12, fontWeight: 700 }}>{dia.substring(0,3).toUpperCase()}</div>
                        <div style={{ fontSize: 11, color: "#6c757d" }}>{fechaNum.substring(0,5)}</div>
                    </div>
                ),



                

cell: (row: DTOMatrizRow) => {
    const celda = row[fecha];
    if (!celda) return <span className="text-muted">—</span>;
    
    const claves = celda.clave.split('/');
    const estiloBase = INCIDENCIA_ESTILOS[claves[0]] || INCIDENCIA_ESTILOS.DEFAULT;

    const variacion = celda.variacionHoraSalida || "";
    

    const parseMinutos = (valor: string) => {
    if (!valor) return 0;

    const sign = valor.startsWith("-") ? -1 : 1;
    const limpio = valor.replace("+", "").replace("-", "");

    const [h, m] = limpio.split(":").map(Number);
    if (isNaN(h) || isNaN(m)) return 0;

    return sign * (h * 60 + m);
};

    const minutosVariacion = parseMinutos(variacion);
        const esMasTiempo = minutosVariacion >=11 ;
    const esMenosTiempo = minutosVariacion <= -30;



    // Formateo de HE (Positivo)
    const hPos = Math.floor(celda.minutosExtraSolo / 60);
    const mPos = celda.minutosExtraSolo % 60;
    
    // Formateo de Descuento (Negativo)
    const minDescAbs = Math.abs(celda.minutosDescuento);
    const hNeg = Math.floor(minDescAbs / 60);
    const mNeg = minDescAbs % 60;

    return (
        // <OverlayTrigger placement="top" overlay={renderTooltipDetalle(celda, fecha)}>
        <OverlayTrigger 
                                placement="auto" 
                                container={document.body} 
                                overlay={(props) => renderTooltipDetalle(celda, fecha, props)}> 
            <div 
                onClick={() => { setEmpleadoParaEditar(row.numEmpleado); setFechaSeleccionada(fecha); setShowGestion(true); }}
                style={{
                    backgroundColor: estiloBase.back, borderRadius: 6, padding: "2px",
                          

                    textAlign: "center", minHeight: 68, width: "100%", cursor: "pointer",
                    // border: `1px solid ${estiloBase.border}`, position: 'relative',
                    border: 
                    esMasTiempo ? "2px solid #a7288c" :
                    // esMenosTiempo ? "2px solid #f1c110" :
                    `2px solid ${estiloBase.border}`,

    

                   
                    
                    display: 'flex', flexDirection: 'column', justifyContent: 'space-between'
                }}>
                
                {/* 1. Claves de incidencia (VAC, PCS, etc) */}
                <div className="d-flex flex-column gap-1">
                    {claves.map((c: string, idx: number) => (
                        <Badge key={idx} bg={INCIDENCIA_ESTILOS[c]?.bg || 'secondary'} style={{ fontSize: 7 }}>
                            {c}
                        </Badge>
                    ))}
                </div>
                
                {/* 2. Badges de Ajustes (HE y DESC separados) */}
                <div className="d-flex flex-column align-items-center gap-1 mt-1">
                    {celda.minutosExtraSolo > 0 && (
                        <Badge bg="purple" style={{ fontSize: 7, padding: '1px 3px', backgroundColor: '#6f42c1' }}>
                            +{hPos}:{mPos.toString().padStart(2, '0')} 
                        </Badge>
                    )}
                    {celda.minutosDescuento < 0 && (
                        <Badge bg="danger" style={{ fontSize: 7, padding: '1px 3px', backgroundColor: '#dc3545' ,  color: 'white' }}>
                            -{hNeg}:{mNeg.toString().padStart(2, '0')} 
                        </Badge>
                    )}

     



                    {celda.retardo && <Badge bg="warning" text="dark" style={{ fontSize: 6, padding: '1px 2px' }}>RET</Badge>}
                </div>

                {/* 3. Horas Finales Totales */}
                <div className="mt-1" style={{ borderTop: '1px solid rgba(0,0,0,0.05)' }}>
                    <div style={{ fontSize: 9, fontWeight: 'bold', color: '#212529' }}>
                        {/* {celda.horasFinales}h */}
                        { celda.horasTotal}h
                    </div>
                      
                                        {/* {variacion && (
                        <div style={{
                            fontSize: 8,
                            fontWeight: 600,
                            color: esMasTiempo ? "#87197a" : "#dc9635ec"
                        }}>
                            {variacion}
                        </div>)} */}

                </div>

                {/* Iconos de notas */}
                {(celda.notaDiaria) && (
                    <BsChatLeftTextFill 
                        size={8} 
                        style={{ position:'absolute', bottom: 2, right: 2, color: '#0d6efd' }}
                    />
                )}

                
            </div>
        </OverlayTrigger>
    )}, 


        width: "105px"
            } as TableColumn<DTOMatrizRow>;
        }), 
    

        {
    name: "Nota Semanal",
    width: "250px",
    cell: (row: DTOMatrizRow) => {
        const algunaFechaConNota = diasColumnas.find(f => row[f]?.notaRH);
        const textoNota = algunaFechaConNota ? row[algunaFechaConNota].notaRH : "";
        const numAdjuntos = adjuntosPorEmpleado.get(row.numEmpleado) || 0;

        return (
            <div 
                className="d-flex align-items-center justify-content-between w-100 p-1"
                style={{ 
                    cursor: 'pointer', 
                    fontSize: '11px', 
                    minHeight: '40px', 
                    border: '1px dashed #6f42c133', 
                    borderRadius: '4px',
                    backgroundColor: textoNota ? '#f3e5f5' : 'transparent'
                }}
                onClick={() => {
                    setEmpleadoSeleccionado(row);
                    setNotaTemp(textoNota || "");
                    setArchivoNuevo(null);
                    setTipoAdjunto("HE");
                    setShowNotaModal(true);
                    // No cargar aquí: useEffect lo hará automáticamente
                }}
            >
                <div style={{ flex: 1, whiteSpace: 'normal', color: textoNota ? '#333' : '#999', fontWeight: textoNota ? '500' : 'normal' }}>
                    {textoNota || "Haga clic para agregar nota semanal..."}
                </div>
                {/* <div className="d-flex align-items-center gap-1">
                    {numAdjuntos > 0 && (
                        <OverlayTrigger placement="left" overlay={<Tooltip>{numAdjuntos} adjunto{numAdjuntos > 1 ? 's' : ''}</Tooltip>}>
                            <span>
                                <BsFileEarmarkText size={14} color="#28a745" />
                            </span>
                        </OverlayTrigger>
                    )}
                    <BsChatLeftTextFill style={{ color: '#6f42c1', opacity: textoNota ? 1 : 0.4 }} />
                </div> */}

                <div className="d-flex align-items-center gap-2">

                    {numAdjuntos > 0 && (
                        <OverlayTrigger
                            placement="left"
                            overlay={
                                <Tooltip>
                                    {numAdjuntos} adjunto{numAdjuntos > 1 ? 's' : ''}
                                </Tooltip>
                            }
                        >
                            <span
                                style={{
                                    backgroundColor: "#e6f4ea",
                                    borderRadius: "50%",
                                    padding: "6px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}
                            >
                                <BsFileEarmarkText size={18} color="#198754" />
                            </span>
                        </OverlayTrigger>
                    )}

                    <OverlayTrigger
                        placement="left"
                        overlay={
                            <Tooltip>
                                {textoNota ? "Nota registrada" : "Sin nota"}
                            </Tooltip>
                        }
                    >
                        <span
                            style={{
                                backgroundColor: textoNota ? "#f3e5f5" : "#f8f9fa",
                                borderRadius: "50%",
                                padding: "6px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                        >
                            <BsChatLeftTextFill
                                size={18}
                                color={textoNota ? "#6f42c1" : "#adb5bd"}
                            />
                        </span>
                    </OverlayTrigger>

                </div>

            </div>
        );
    }
}



        
    ];






    return (
        <div className="p-1" style={{ height: '98vh', display: 'flex', flexDirection: 'column', backgroundColor: '#f8f9fa' }}>
            <Card className="mb-1 border-0 shadow-sm">
                <Card.Body className="py-1 px-2">
                    <Form>
                        <Row className="g-1 align-items-end">
                            <Col xs={2}><Form.Label className="small mb-0 fw-bold">Desde</Form.Label><Form.Control size="sm" type="date" value={inicio} onChange={e => setInicio(e.target.value)} /></Col>
                            <Col xs={2}><Form.Label className="small mb-0 fw-bold">Hasta</Form.Label><Form.Control size="sm" type="date" value={fin} onChange={e => setFin(e.target.value)} /></Col>
                            <Col xs={3}><Form.Label className="small mb-0 fw-bold">Buscar</Form.Label><Form.Control size="sm" placeholder="Empleado..." onChange={e => setFiltro(e.target.value)} /></Col>
                                    <Col xs="auto">
                                    <Button
                                        size="sm"
                                        variant="outline-info"
                                        className="mt-4 px-2 py-1 small"
                                        onClick={() => setShowPeriodosModal(true)}
                                    >
                                        <BsCalendarCheck size={12} className="me-1" />
                                        Periodos
                                    </Button>
                                    </Col>

                                    
                                    <Col xs={4} className="d-flex gap-1">
                                        <Button size="sm" className="flex-grow-1" onClick={generarReporte}><BsSearch /> Buscar</Button>
                                        <Button size="sm" variant="success" className="flex-grow-1" onClick={() => downloadExcel(matrizData, diasColumnas)}><BsFileEarmarkExcel /> Excel</Button>
                                    </Col>

                        </Row>
                    </Form>
                </Card.Body>
            </Card>

            <div style={{ flex: 1, overflow: 'hidden' }} className="shadow-sm rounded bg-white border">
                <DataTable 
                    columns={columnsMatriz} 
                    data={matrizData} 
                    dense 
                    striped 
                    highlightOnHover 
                    pagination 
                    fixedHeader 
                    fixedHeaderScrollHeight="calc(100vh - 145px)" 
                />
            </div>



            <Offcanvas 
                show={showGestion} 
                onHide={() => { setShowGestion(false); generarReporte(); }} 
                placement="end" 
                style={{ width: '45%' }} 
                backdrop={false} 
                scroll={true}
            >
                <Offcanvas.Header closeButton className="bg-primary text-white py-2 shadow-sm">
                    <Offcanvas.Title className="small fw-bold">
                        Ajuste: {obtenerFechaFormateada(fechaSeleccionada, { day: "2-digit", month: "2-digit", year: "numeric" })}
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body style={{ backgroundColor: "#f8f9fa" }}>
                    {showGestion && (
                        <GestionChecadasComponent 
                            empleadoFiltro={empleadoParaEditar} 
                            fechaInicioFiltro={fechaSeleccionada} 
                            fechaFinFiltro={fechaSeleccionada}
                            // fechaFinFiltro={fin}
                            notaInicial={matrizData.find(m => m.numEmpleado === empleadoParaEditar)?.[fechaSeleccionada]?.notaDiaria || ''}
                        />
                    )}
                    <div className="d-grid mt-4">
                        <Button variant="secondary" onClick={() => { setShowGestion(false); generarReporte(); }}>Cerrar y Actualizar Matriz</Button>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>

                    <ModalPeriodosCerradosAdmin
            show={showPeriodosModal}
            onHide={() => setShowPeriodosModal(false)}

            initialFechaInicio={inicio}
            initialFechaFin={fin}

            onSelectPeriodo={(nuevoInicio, nuevoFin) => {
                setInicio(nuevoInicio);
                setFin(nuevoFin);
                generarReporte(); // opcional pero recomendado
            }}

            idSupervisorPropio={Number(
                localStorage.getItem("IdSupervisorPropio")?.replace(/['"]+/g, '') || 0
            )}
            idUsuario={Number(
                localStorage.getItem("UserId")?.replace(/['"]+/g, '') || 0
            )}

            />




                    
           





<Modal 
    show={showNotaModal} 
    
    onHide={() => { 
    setShowNotaModal(false); 
    setAdjuntos([]);
    setArchivoNuevo(null);
    setTipoAdjunto("HE");
    setNotaTemp("");
    setEmpleadoSeleccionado(null);
}}
    size="lg" 
    centered
>
    <Modal.Header closeButton className="bg-primary text-white py-2 shadow-sm">
        <Modal.Title className="fs-6 fw-bold">
            <BsChatLeftTextFill className="me-2" />
            Gestión de Nómina: {empleadoSeleccionado?.nombreEmpleado}
        </Modal.Title>
    </Modal.Header>
    
    <Modal.Body className="bg-light">
        <Row>
            {/* SECCIÓN IZQUIERDA: NOTA SEMANAL (se mantiene igual) */}
            <Col md={6}>
                <Form.Group>
                    <Form.Label className="small fw-bold">Observaciones del Rango (RH)</Form.Label>
                    <Form.Control 
                        as="textarea" 
                        rows={8} 
                        value={notaTemp} 
                        onChange={(e) => setNotaTemp(e.target.value)}
                        placeholder="Escriba la nota que aplicará a toda la semana..."
                        className="shadow-sm border-0"
                    />
                    <div className="mt-2 text-muted" style={{ fontSize: '10px' }}>
                        Periodo activo: {inicio} al {fin}
                    </div>
                </Form.Group>
                
                <div className="d-flex gap-2 mt-3">
                    <Button 
                        variant="outline-primary" 
                        size="sm" 
                        className="flex-grow-1" 
                        onClick={() => manejarNotaRH('GUARDAR')}
                    >
                        {notaTemp ? '💾 Actualizar Nota' : '💾 Guardar Nota'}
                    </Button>
                    {notaTemp && (
                        <Button variant="outline-danger" size="sm" onClick={() => manejarNotaRH('ELIMINAR')}>
                            🗑️ Eliminar
                        </Button>
                    )}
                </div>
            </Col>

            {/* SECCIÓN DERECHA: ADJUNTOS DEL PERIODO (NUEVO SISTEMA) */}
            <Col md={6} className="border-start">
                <Form.Label className="small fw-bold d-block mb-3">
                    Adjuntos del Periodo ({adjuntos.length})
                </Form.Label>

                {/* Lista de adjuntos existentes */}
                {adjuntos.length === 0 ? (
                    <div className="text-muted small text-center py-5 border rounded bg-light">
                        No hay adjuntos en esta semana
                    </div>
                ) : (
                    <div className="d-flex flex-column gap-2 mb-4">
                        {adjuntos.map((adj) => (
                            <div
                                key={adj.id}
                                className="p-3 border rounded bg-white shadow-sm d-flex justify-content-between align-items-center"
                            >
                                <div className="flex-grow-1">
                                    <Badge bg="info" className="me-2">{adj.tipoAdjunto}</Badge>
                                    <div className="small fw-bold text-truncate" style={{ maxWidth: '170px' }}>
                                        {adj.nombreOriginal}
                                    </div>
                                    <div className="text-muted" style={{ fontSize: '10px' }}>
                                        {new Date(adj.fechaSubida).toLocaleDateString('es-MX')}
                                    </div>
                                </div>
                                <div className="d-flex gap-2">
   <Button
    variant="outline-success"
    size="sm"
    onClick={() => nominaServices.verAdjuntoEnNuevaPestana(adj.id)}
>
    👁️ Ver en nueva pestaña
</Button>

    <Button
        variant="outline-danger"
        size="sm"
        onClick={async () => {
            if (!window.confirm("¿Eliminar este adjunto?")) return;

            try {
                
                    await nominaServices.eliminarAdjunto(adj.id);
                setMsg("Adjunto eliminado correctamente");
                setHeader("Éxito");
                setShowMsg(true);
                cargarAdjuntos(); 
            } catch (error) {
                setMsg("Error al eliminar adjunto");
                setHeader("Error");
                setShowMsg(true);
            }
        }}
    >
        🗑️ Eliminar
    </Button>
</div>

                                
                            </div>
                        ))}
                    </div>
                )}

                {/* Selector de tipo de adjunto */}
                <Form.Group className="mb-3">
                    <Form.Label className="small fw-bold">Tipo de documento</Form.Label>
                    <Form.Select
                        size="sm"
                        value={tipoAdjunto}
                        onChange={(e) => setTipoAdjunto(e.target.value)}
                    >
                        <option value="HE">Horas Extras (HE)</option>
                        {/* <option value="VAC">Vacaciones</option> */}
                        <option value="INC">Incapacidad</option>
                        {/* <option value="RET">Justificante Retardo</option> */}
                        <option value="OTRO">Otro documento</option>
                    </Form.Select>
                </Form.Group>

                {/* Área de selección de archivo */}
                <div
                    className="p-4 border rounded text-center border-dashed mb-3"
                    style={{
                        cursor: 'pointer',
                        backgroundColor: archivoNuevo ? '#f0fff4' : '#f8f9fa',
                        borderColor: archivoNuevo ? '#198754' : '#adb5bd',
                        minHeight: '150px'
                    }}
                    onClick={() => document.getElementById('inputArchivoNuevo')?.click()}
                >
                    <input
                        id="inputArchivoNuevo"
                        type="file"
                        hidden
                        accept=".jpg,.jpeg,.png,.pdf"
                        onChange={(e) => setArchivoNuevo(e.target.files?.[0] || null)}
                    />

                    {archivoNuevo ? (
                        <div>
                            <Badge bg="success" className="mb-2">Seleccionado</Badge>
                            <div className="small fw-bold text-truncate" style={{ maxWidth: '200px' }}>
                                {archivoNuevo.name}
                            </div>
                            <Button
                                variant="link"
                                size="sm"
                                className="text-danger p-0 mt-1"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setArchivoNuevo(null);
                                }}
                            >
                                Cambiar archivo
                            </Button>
                        </div>
                    ) : (
                        <div>
                            <BsFileEarmarkExcel size={40} className="mb-3 text-primary" />
                            <div className="fw-bold small">Haz clic para seleccionar archivo</div>
                            <div className="text-muted" style={{ fontSize: '10px' }}>
                                JPG, PNG o PDF
                            </div>
                        </div>
                    )}
                </div>

                {/* Botón de subir */}
                <Button
                    variant="success"
                    className="w-100 fw-bold"
                    disabled={!archivoNuevo}
                    onClick={manejarSubidaAdjunto}
                >
                    📤 Subir como {tipoAdjunto}
                </Button>
            </Col>
        </Row>
    </Modal.Body>

    <Modal.Footer className="bg-white border-top-0">
        <Button variant="secondary" size="sm" onClick={() => setShowNotaModal(false)}>
            Cerrar Ventana
        </Button>
    </Modal.Footer>
</Modal>










































  




            <MsgInformativo show={showMsg} header={header} msg={msg} msgColor="primary" closeToast={() => setShowMsg(false)} />
        </div>
    );
}